import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  modal: {
    padding: '60px 40px',
    textAlign: 'center',
    '& .MuiButton-root': {
      marginTop: '40px'
    },
    '& img': {
      marginBottom: '12px'
    }
  }
});
export default useStyles;